import React from "react";
import { absMediaUrl } from "@/components/marketplace/MediaPicker";
import { STATUS_TONE, fmtDate, isDateField, isMediaField, isMoneyField, humanize } from "./crudUtils";

export const StatusPill = ({ value, testid }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] font-semibold ring-1 ring-inset capitalize ${STATUS_TONE(value)}`} data-testid={testid}>
    <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
    {String(value || "none").replace(/_/g, " ")}
  </span>
);

export default function CellValue({ field, value, statusField }) {
  if (value == null || value === "") return <span className="text-slate-300">—</span>;
  if (field === statusField || /status$/.test(field)) return <StatusPill value={value} />;
  if (typeof value === "boolean") return value
    ? <span className="text-xs font-medium text-emerald-700">Yes</span>
    : <span className="text-xs text-slate-400">No</span>;
  if (isMediaField(field) && typeof value === "string") return <img src={absMediaUrl(value)} alt="" className="h-8 w-8 rounded-lg object-cover ring-1 ring-slate-200" />;
  if (typeof value === "number" && isMoneyField(field)) return <span className="tabular-nums font-medium text-[#071b22]">${value.toLocaleString(undefined, { maximumFractionDigits: 2 })}</span>;
  if (typeof value === "number") return <span className="tabular-nums">{value.toLocaleString()}</span>;
  if (isDateField(field, value) && typeof value === "string") return <span className="text-slate-600 whitespace-nowrap">{fmtDate(value)}</span>;
  if (Array.isArray(value)) return <span className="text-slate-600">{value.length ? value.slice(0, 2).map((v) => (typeof v === "object" ? "…" : humanize(String(v)))).join(", ") + (value.length > 2 ? ` +${value.length - 2}` : "") : "—"}</span>;
  if (typeof value === "object") return <span className="text-slate-400 text-xs">{Object.keys(value).length} fields</span>;
  const s = String(value);
  return <span className="text-slate-700" title={s}>{s.length > 36 ? s.slice(0, 36) + "…" : s}</span>;
}
